import { apiPrefix } from "@/config/config";
import { api, teacherAuthApi } from "../interceptor/api.interceptor";

class TeacherService {
  // Public routes
  static async sendOtp(data) {
    return await api
      .post(`/${apiPrefix}/send-otp`, data)
      .then((res) => res?.data?.data);
  }

  static async verifyOtp(data) {
    return await api
      .post(`/${apiPrefix}/verify-otp`, data)
      .then((res) => res?.data?.data);
  }

  static async login(data) {
    return await api
      .post(`/${apiPrefix}/instructor/login`, data)
      .then((res) => res?.data);
  }

  // Authenticated routes
  static async getProfile() {
    return await teacherAuthApi
      .get(`/${apiPrefix}/instructor/profile`)
      .then((res) => res?.data?.data);
  }

  static async updateProfile(formData) {
    return await teacherAuthApi
      .post(`/${apiPrefix}/instructor/profile`, formData)
      .then((res) => res?.data?.data);
  }

  static async updatePassword(data) {
    return await teacherAuthApi
      .post(`/${apiPrefix}/instructor/update-password`, data)
      .then((res) => res?.data?.data);
  }

  // Authenticated routes
  static async getDashboardInfo(params = {}) {
    return await teacherAuthApi
      .get(`/${apiPrefix}/instructor/dashboard`, { params })
      .then((res) => res?.data?.data);
  }

  static async getMycourses(page = 1, perPage = 15) {
    return await teacherAuthApi
      .get(`/${apiPrefix}/instructor/courses?page=${page}&per_page=${perPage}`)
      .then((res) => res?.data?.data);
  }

  static async getRoutines() {
    return await teacherAuthApi
      .get(`/${apiPrefix}/instructor/routineInfo`)
      .then((res) => res?.data?.data);
  }
  static async allExams() {
    return await teacherAuthApi
      .get(`/${apiPrefix}/instructor/allExams`)
      .then((res) => res?.data?.data);
  }

  static async getPositions(params) {
    return await teacherAuthApi
      .get(`/${apiPrefix}/instructor/result-position`, { params })
      .then((res) => res?.data?.data)
      .catch((err) => {
        console.error("Failed to fetch positions:", err);
        throw err;
      });
  }
  static async getResult(params) {
    return await teacherAuthApi
      .get(`/${apiPrefix}/instructor/results`, { params })
      .then((res) => res?.data?.data)
      .catch((err) => {
        console.error("Failed to fetch positions:", err);
        throw err;
      });
  }

  static async getMyCourseDetails(courseSlug, subjectSlug) {
    try {
      return await teacherAuthApi
        .get(
          `/${apiPrefix}/instructor/courses/${courseSlug}/subject/${subjectSlug}`
        )
        .then((res) => res?.data?.data);
    } catch (error) {}
  }

  static async instructorReviews(formData) {
    return await teacherAuthApi
      .post(`/${apiPrefix}/instructor/lecture-review`, formData)
      .then((res) => res?.data?.data);
  }
  static async sendMessages(formData) {
    return await teacherAuthApi
      .post(`/${apiPrefix}/instructor/messages`, formData)
      .then((res) => res?.data?.data);
  }

  static async getMessages(params = {}) {
    console.log("params", params);
    return await teacherAuthApi
      .get(`/${apiPrefix}/instructor/messages`, { params })
      .then((res) => res?.data)
      .catch((err) => {
        console.error("Failed to fetch messages:", err);
        throw err;
      });
  }

    static async updateMessage(id, data) {
    return await teacherAuthApi
      .post(`/${apiPrefix}/instructor/messages/${id}/update`, data)
      .then((res) => res?.data?.data);
  }
  

  static async getResultEvaluation(params = {}) {
    console.log("params", params);
    return await teacherAuthApi
      .get(`/${apiPrefix}/instructor/answer-evaluation`, { params })
      .then((res) => res?.data?.data)
      .catch((err) => {
        console.error("Failed to fetch messages:", err);
        throw err;
      });
  }

  static async uploadWrittenAnswerPdf(formData) {
    return await teacherAuthApi
      .post(`/${apiPrefix}/instructor/upload-written-answer-pdf`, formData)
      .then((res) => res?.data?.data);
  }
  static async updateResult(formData) {
    return await teacherAuthApi
      .post(`/${apiPrefix}/instructor/updateResult`, formData)
      .then((res) => res?.data?.data);
  }

  static async getNotifications(params = {}) {
    return await teacherAuthApi
      .get(`/${apiPrefix}/instructor/notifications`, { params })
      .then((res) => res?.data?.data);
  }

 
  static async markNotificationAsRead(notificationUserId) {
    return await teacherAuthApi
      .post(`/${apiPrefix}/instructor/notifications/read`, {
        notification_user_id: notificationUserId,
      })
      .then((res) => res?.data?.data);
  }

  static async forgetPassword(data) {
    return await api
      .post(`/${apiPrefix}/instructor/forget-password`, data)
      .then((res) => res?.data?.data);
  }


  
   static async getMycourses(page = 1, perPage = 15) {
      return await teacherAuthApi
        .get(`/${apiPrefix}/instructor/courses?page=${page}&per_page=${perPage}`)
        .then((res) => res?.data?.data);
    }


    
   static async getMyCourseDetails(courseSlug, subjectSlug) {
    try {
      return await teacherAuthApi
        .get(
          `/${apiPrefix}/instructor/courses/${courseSlug}/subject/${subjectSlug}`
        )
        .then((res) => res?.data?.data);
    } catch (error) {}
  }

}

export default TeacherService;
